import React, { useContext, useImperativeHandle, useState } from 'react';
// import { connect } from 'react-redux';
import { ChevronRight as ArrowDropDownIcon } from 'shared/components/AppIcons';
import {
    Box,
    Typography,
    Collapse,
    FormControl,
    FormLabel,
    RadioGroup,
    Grid,
    FormGroup,
    TextField,
    // Badge,
} from '@mui/material';
import {
    AppRadioBox,
    AppFormikTextField,
    AppPrimaryButton,
    AppOutlinedRadioInput,
    AppFormikDatePicker,
    AppFormikTextFieldNumber,
    ButtonComp,
} from 'shared/components/AppComponents';
import { Formik, FormikHelpers, FormikProps } from 'formik';
import { sendRequest } from './data/fetch';
import { checkboxStatus } from './data/checkboxStatus';
import { checkboxType } from './data/checkboxType';
import { setSidebarPacket } from 'state/baseapplication/Action';
import { useSelector, useDispatch } from 'react-redux';
import { SocketActions } from 'state/socket/Action';
import { APIManager } from 'shared/manager/APIManager';
import { abortProtocol } from './data/Main';
import { useUpdateEffect } from 'react-use';
import { Data } from './VirtualizedTable';
import { ListingMeta } from '../ManagePacketsPage';
// import RefreshIcon from '@mui/icons-material/Refresh';

const FilterSidebar: React.FC<FilterSidebar> = React.forwardRef(
    (
        {
            setData,
            setTotalRows,
            page,
            setPage,
            setIsLoading,
            rowsPerPage,
            isLoading,
        },
        ref
    ) => {
        /**
         * The State is use when redux sidebar is implemented
         */
        const {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            textField: reduxTextField,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            searchBy: reduxSearchBy,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            sortBy: reduxSortBy,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            packetStatus: reduxPacketStatus,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            packetType: reduxPacketType,
            binNumber,
            clientName,
            cm9Number,
            loanNumber,
            operatorId,
            slaDaysLeft,

            uploadAge,
            uploadDate,
            completedDate,
        } = useSelector(
            (state: any) => state.baseAppState.sidebarOptions.managePacket
        );
        const role = useSelector((state: any) => state.authState.role);
        const dispatch = useDispatch();
        const [isNonRetry, setNonRetry] = React.useState<boolean>(false);
        const [checkedByLoan, setByLoan] = useState<boolean>(false);
        const [checkedByBin, setByBin] = useState<boolean>(false);
        const [checkedByClient, setByClient] = useState<boolean>(false);
        const [checkedByOperator, setByOperator] = useState<boolean>(false);
        const [checkedByCM9, setByCM9] = useState<boolean>(false);
        const [checkedByUploadDate, setByUploadDate] = useState<boolean>(false);
        const [checkedByCompletedDate, setByCompletedDate] =
            useState<boolean>(false);
        const [checkedBySLADate, setBySLADate] = useState<boolean>(false);
        const [checkedByUploadAge, setByUploadAge] = useState<boolean>(false);
        const [openSortByMenu, setOpenSortByMenu] = useState(!!reduxSortBy);
        const [openSearchByMenu, setOpenSearchMenu] = useState(!!reduxSearchBy);
        const [isSubmitting, setSubmitting] = useState<boolean>(false);
        const [activeData, setActiveData] = useState<Data[]>([]);
        const [openFilterByPacketStatusMenu, setOpenFilterPacketStatusMenu] =
            useState(
                !!(
                    Array.isArray(reduxPacketStatus) &&
                    reduxPacketStatus.length > 0
                )
            );
        const [openFilterByPacketTypeMenu, setOpenFilterPacketTypeMenu] =
            useState(
                !!(Array.isArray(reduxPacketType) && reduxPacketType.length > 0)
            );
        const ListingMetaProps = useContext(ListingMeta);

        // Filter state
        const [searchBy, setSearchBy] = useState(reduxSearchBy ?? '');
        const [sortBy, setSortBy] = useState(reduxSortBy ?? '');
        const [textField, setTextField] = useState(reduxTextField ?? '');
        const [packetStatus, setPacketStatus] = useState<string[]>(
            reduxPacketStatus ?? []
        );
        const [packetType, setPacketType] = useState<string[]>(
            reduxPacketType ?? []
        );
        const formikRef = React.useRef<FormikProps<FormikPropsValues> | null>(
            null
        );
        const [isRefreshListing, setRefreshListing] =
            React.useState<boolean>(false);

        const socketState = useSelector(
            (stateRedux: any) => stateRedux.socketState
        );
        const socketEvent = React.useMemo(
            () => socketState.socketData.eventName,
            [socketState.socketData.eventName]
        );

        const [isSubmit, setSubmit] = useState<boolean>(false);

        useUpdateEffect(() => {
            if (isSubmit === true) {
                setSubmitting(true);
                setSubmit(false);
            } else if (isLoading === false) {
                setSubmitting(isLoading);
            }
        }, [isLoading, isSubmit]);
        /**
         * Update the data and related state variables.
         *
         * @param {any} e - The data to update.
         * @param {number} totalRows - The total number of rows.
         * @param {any} formik - The formik object (optional).
         */
        const updateData = React.useCallback(
            (
                e: any,
                totalRows: number,
                formik: any,
                isNetworkError: boolean
            ): void => {
                setData(e);
                setActiveData(e);
                if (formik) {
                    formik.setSubmitting(false);
                }
                ListingMetaProps?.setGlobalRefreshing(false);
                setTotalRows(totalRows);
                setIsLoading(false);

                ListingMetaProps?.setNetworkError(isNetworkError);
            },
            [ListingMetaProps, setData, setIsLoading, setTotalRows]
        );

        // useLayoutEffect(() => {
        //     if (formikRef.current?.isSubmitting && isLoading === false) {
        //         formikRef.current.setSubmitting(false);
        //     }
        // }, [isLoading]);

        /**
         * Handle state changes for various fields.
         *
         * @param {'packetStatus' | 'packetType' | 'searchBy' | 'sortBy'} type - The type of state to update.
         * @param {React.SetStateAction<string>} value - The new value for the state.
         */
        const handleChange = React.useCallback(
            (
                type: 'packetStatus' | 'packetType' | 'searchBy' | 'sortBy',
                value: React.SetStateAction<any>
            ): void => {
                ListingMetaProps?.setGlobalRefreshing(true);
                const values = formikRef.current?.values;
                switch (type) {
                    case 'searchBy':
                        setSearchBy(value);
                        break;
                    case 'sortBy':
                        setSortBy(value);
                        break;
                    default:
                        break;
                }
                dispatch(
                    setSidebarPacket({
                        textField,
                        searchBy: type === 'searchBy' ? value : searchBy,
                        sortBy: type === 'sortBy' ? value : sortBy,
                        packetStatus:
                            type === 'packetStatus' ? value : packetStatus,
                        packetType: type === 'packetType' ? value : packetType,
                        binNumber: values?.search_bin ?? '',
                        clientName: values?.search_client ?? '',
                        cm9Number: values?.search_cm9 ?? '',
                        loanNumber: values?.search_loan ?? '',
                        operatorId: values?.search_operator ?? '',
                        slaDaysLeft: values?.search_sladate,
                        completedDate: values?.search_datepicker_completeddate,
                        uploadAge: values?.search_uploadage,
                        uploadDate: values?.search_datepicker_uploaddate,
                    })
                );
                setIsLoading(true);
                sendRequest(
                    values?.search_loan ?? '',
                    values?.search_bin ?? '',
                    values?.search_client ?? '',
                    values?.search_operator ?? '',
                    values?.search_cm9 ?? '',
                    values?.search_datepicker_uploaddate ?? '',
                    values?.search_datepicker_completeddate ?? '',
                    values?.search_sladate ?? 0,
                    values?.search_uploadage ?? 0,
                    type === 'sortBy' ? value : sortBy,
                    false,
                    page + 1,
                    rowsPerPage,
                    type === 'packetStatus' ? value : packetStatus,
                    type === 'packetType' ? value : packetType,
                    (
                        e: any[],
                        totalRows: number,
                        formik: any,
                        isNetworkError: boolean
                    ) => {
                        updateData(e, totalRows, formik, isNetworkError);
                    }
                );
            },
            [
                ListingMetaProps,
                dispatch,
                textField,
                searchBy,
                sortBy,
                packetStatus,
                packetType,
                setIsLoading,
                page,
                rowsPerPage,
                updateData,
            ]
        );

        /**
         * Handle changes in the searchBy state.
         *
         * @param {Object} event - The event object.
         */
        // const handleChangeSearchBy = (event: {
        //     target: { value: React.SetStateAction<string> };
        // }): void => {
        //     setPage(0);
        //     handleChange('searchBy', event.target.value);
        // };

        /**
         * Handle changes in the sortBy state.
         *
         * @param {Object} event - The event object.
         */
        const handleChangeSortBy = (event: {
            target: { value: React.SetStateAction<string> };
        }): void => {
            setPage(0);
            handleChange('sortBy', event.target.value);
        };

        /**
         * Executes the `handleChange` function with 'searchBy' type and the current value of searchBy state
         * whenever the 'page' state changes.
         */
        React.useEffect(() => {
            handleChange('searchBy', searchBy);
        }, [page, rowsPerPage]);

        useUpdateEffect(() => {
            setNonRetry(false);
        }, [page]);

        React.useEffect(() => {
            if (socketEvent !== null) {
                // console.log('socketstat', socketState);
                if (
                    (socketEvent === 'packetStatus' ||
                        socketEvent === 'operatorAction') &&
                    ListingMetaProps?.activeListing === false &&
                    activeData &&
                    Array.isArray(activeData) &&
                    activeData.length > 0
                ) {
                    const socketPacketId = socketState.socketData.packetId;
                    if (
                        activeData.some(
                            (e) => e.actions.uuid === socketPacketId
                        )
                    ) {
                        setRefreshListing(true);
                    } else {
                        setNonRetry(true);
                    }
                }
                dispatch(SocketActions.ResetSocketEvent({}));
            }
        }, [socketEvent]);
        /**
         * Executes the `handleChange` function with refresh from socket connection
         */
        React.useEffect(() => {
            if (isRefreshListing) {
                handleChange('searchBy', searchBy);
                setRefreshListing(false);
            }
        }, [isRefreshListing]);

        /**
         * Handle changes in the packet status checkbox.
         *
         * @param {React.ChangeEvent<HTMLInputElement>} event - The event object.
         */
        const handleChangePacketStatus = (
            event: React.ChangeEvent<HTMLInputElement>
        ): void => {
            const data = event.target.value;
            let updatedPacketStatus;

            if (data === 'viewall') {
                updatedPacketStatus = event.target.checked ? [] : packetStatus;
            } else if (event.target.checked) {
                updatedPacketStatus = [...packetStatus, data];
            } else {
                updatedPacketStatus = packetStatus.filter(
                    (item) => item !== data
                );
            }

            setPacketStatus(updatedPacketStatus);
            setPage(0);
            handleChange('packetStatus', updatedPacketStatus);
        };

        /**
         * Handle changes in the packet type checkbox.
         *
         * @param {React.ChangeEvent<HTMLInputElement>} event - The event object.
         */
        const handleChangePacketType = (
            event: React.ChangeEvent<HTMLInputElement>
        ): void => {
            const data = event.target.value;
            let updatedPacketType;

            if (data === 'viewall') {
                updatedPacketType = event.target.checked ? [] : packetType;
            } else if (event.target.checked) {
                updatedPacketType = [...packetType, data];
            } else {
                updatedPacketType = packetType.filter((item) => item !== data);
            }

            setPacketType(updatedPacketType);
            setPage(0);
            handleChange('packetType', updatedPacketType);
        };

        const resetSearch = React.useCallback((): void => {
            const { current: formik } = formikRef;
            if (formik) {
                setByLoan(false);
                setByBin(false);
                setByClient(false);
                setByOperator(false);
                setByCM9(false);
                setByUploadDate(false);
                setByUploadAge(false);
                setByCompletedDate(false);
                setBySLADate(false);

                formik.setFieldValue('search_loan', '');
                formik.setFieldValue('search_bin', '');
                formik.setFieldValue('search_client', '');
                formik.setFieldValue('search_operator', '');
                formik.setFieldValue('search_cm9', '');
                formik.setFieldValue('search_datepicker_uploaddate', '');
                formik.setFieldValue('search_datepicker_completeddate', '');
                formik.setFieldValue('search_sladate', '');
                formik.setFieldValue('search_uploadage', '');
                setTextField('');

                if (formik) formik.handleReset();
            }
        }, []);
        const FormikValues = React.useMemo(
            () => (formikRef.current ? formikRef.current.initialValues : null),
            [formikRef.current]
        );

        React.useLayoutEffect(() => {
            if (FormikValues) {
                if (
                    typeof FormikValues.search_loan === 'string' &&
                    FormikValues.search_loan !== '' &&
                    checkedByLoan === false
                ) {
                    setByLoan(true);
                }
                if (
                    typeof FormikValues.search_client === 'string' &&
                    FormikValues.search_client !== '' &&
                    checkedByClient === false
                ) {
                    setByClient(true);
                }
                if (
                    typeof FormikValues.search_bin === 'string' &&
                    FormikValues.search_bin !== '' &&
                    checkedByBin === false
                ) {
                    setByBin(true);
                }
                if (
                    typeof FormikValues.search_operator === 'string' &&
                    FormikValues.search_operator !== '' &&
                    checkedByOperator === false
                ) {
                    setByOperator(true);
                }
                if (
                    typeof FormikValues.search_cm9 === 'string' &&
                    FormikValues.search_cm9 !== '' &&
                    checkedByCM9 === false
                ) {
                    setByCM9(true);
                }
                if (
                    (typeof FormikValues.search_datepicker_uploaddate ===
                        'string' ||
                        typeof FormikValues.search_datepicker_uploaddate ===
                            'object') &&
                    FormikValues.search_datepicker_uploaddate !== '' &&
                    checkedByUploadDate === false
                ) {
                    setByUploadDate(true);
                }

                if (
                    (typeof FormikValues.search_datepicker_completeddate ===
                        'string' ||
                        typeof FormikValues.search_datepicker_completeddate ===
                            'object') &&
                    FormikValues.search_datepicker_completeddate !== '' &&
                    checkedByCompletedDate === false
                ) {
                    setByCompletedDate(true);
                }

                if (
                    FormikValues.search_sladate !== 0 &&
                    typeof FormikValues.search_sladate === 'number' &&
                    Number.isNaN(FormikValues.search_sladate) === false &&
                    checkedBySLADate === false
                ) {
                    setBySLADate(true);
                }

                if (
                    FormikValues.search_uploadage !== 0 &&
                    typeof FormikValues.search_uploadage === 'number' &&
                    Number.isNaN(FormikValues.search_uploadage) === false &&
                    checkedByUploadAge === false
                ) {
                    setByUploadAge(true);
                }
            }
        }, [FormikValues]);
        /**
         * Handle button reset, for status reset.
         *
         * @param {React.ChangeEvent<HTMLInputElement>} any - The event object.
         */
        const handleReset = React.useCallback(
            (formik: any, callback: any): void => {
                // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                const revocation = () => {
                    setSubmit(true);
                    setIsLoading(true);
                };
                if (abortProtocol.protocol) {
                    APIManager.target.addEventListener(
                        'revocation',
                        revocation
                    );
                }
                setIsLoading(true);
                sendRequest(
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    '',
                    0,
                    0,
                    'oldestToNew',
                    formik,
                    page + 1,
                    rowsPerPage,
                    [],
                    [],
                    (
                        e: any[],
                        totalRows: number,
                        formik: any,
                        isNetworkError: boolean
                    ) => {
                        APIManager.target.removeEventListener(
                            'revocation',
                            revocation
                        );
                        setSearchBy('');
                        setSortBy('oldestToNew');
                        setTextField('');
                        setPacketStatus([]);
                        setPacketType([]);
                        setTextField('');
                        dispatch(
                            setSidebarPacket({
                                textField: '',
                                searchBy: '',
                                sortBy: 'oldestToNew',
                                packetStatus: '',
                                packetType: '',
                                binNumber: '',
                                clientName: '',
                                cm9Number: '',
                                loanNumber: '',
                                operatorId: '',
                                slaDaysLeft: 0,
                                completedDate: '',
                                uploadAge: '',
                                uploadDate: '',
                            })
                        );
                        updateData(e, totalRows, formik, isNetworkError);
                        formik.setSubmitting(false);
                        callback();
                    }
                );
            },
            [dispatch, page, rowsPerPage, setIsLoading, updateData]
        );

        /**
         * Handle changes request filter dashboard
         *
         * @param {string} textfield - 'the content textfield sidebar'
         * @param {string} formik - 'the content formik sidebar'
         */
        const reqFilterPacket = React.useCallback(
            (
                textfieldLoan: string,
                textfieldBin: string,
                textfieldClient: string,
                textfieldOperator: string,
                textfieldCM9: string,
                textfieldUploadDate: string,
                textfieldCompletedDate: string,
                textfieldSLALeft: number | string,
                textfieldUploadAge: number | string,
                formik: FormikHelpers<any> | boolean
            ): void => {
                dispatch(
                    setSidebarPacket({
                        textField,
                        searchBy,
                        sortBy,
                        packetStatus,
                        packetType,
                        binNumber: textfieldBin,
                        clientName: textfieldClient,
                        cm9Number: textfieldCM9,
                        loanNumber: textfieldLoan,
                        operatorId: textfieldOperator,
                        slaDaysLeft: textfieldSLALeft,
                        completedDate: textfieldCompletedDate,
                        uploadAge: textfieldUploadAge,
                        uploadDate: textfieldUploadDate,
                    })
                );
                setIsLoading(true);
                sendRequest(
                    textfieldLoan,
                    textfieldBin,
                    textfieldClient,
                    textfieldOperator,
                    textfieldCM9,
                    textfieldUploadDate,
                    textfieldCompletedDate,
                    typeof textfieldSLALeft === 'number' ? textfieldSLALeft : 0,
                    typeof textfieldUploadAge === 'number'
                        ? textfieldUploadAge
                        : 0,
                    sortBy,
                    formik,
                    1,
                    rowsPerPage,
                    packetStatus,
                    packetType,
                    (
                        e: any[],
                        totalRows: number,
                        formik: any,
                        isNetworkError: boolean
                    ) => {
                        updateData(e, totalRows, formik, isNetworkError);
                    }
                );
            },
            [
                dispatch,
                packetStatus,
                packetType,
                rowsPerPage,
                searchBy,
                setIsLoading,
                sortBy,
                textField,
                updateData,
            ]
        );

        const HandleClearInSearchBox = React.useCallback(
            (ev: { preventDefault: () => void }) => {
                ev.preventDefault();
                resetSearch();
                setSearchBy('');
                dispatch(
                    setSidebarPacket({
                        textField,
                        searchBy: '',
                        sortBy,
                        packetStatus,
                        packetType,
                    })
                );
                // handleChange('searchBy', '');
                reqFilterPacket('', '', '', '', '', '', '', '', '', false);
            },
            [
                dispatch,
                packetStatus,
                packetType,
                reqFilterPacket,
                resetSearch,
                sortBy,
                textField,
            ]
        );

        useImperativeHandle(
            ref,
            () => ({
                triggerChangeSortBy: (val: string) => {
                    // console.log('page changes');
                    setPage(0);
                    handleChange('sortBy', val);
                },
                getRefreshData: () => {
                    handleChange('searchBy', searchBy);
                },
                getValueSortBy: () => sortBy,
            }),
            [handleChange, searchBy, setPage, sortBy]
        );

        // useEffect(() => {
        //     const timeout = setInterval(() => {
        //         handleChange('searchBy', searchBy);
        //     }, 15000);
        //     return () => {
        //         clearInterval(timeout);
        //     };
        // }, [searchBy, handleChange]);

        return (
            <Box className="side-menu-filter-and-sorting">
                <Box className="menu-container">
                    <ButtonComp
                        className="action-button"
                        type="success"
                        fullWidth
                        disabled={isNonRetry === false}
                        onClick={() => {
                            setRefreshListing(true);
                            setNonRetry(false);
                        }}
                        aria-haspopup="dialog"
                        // endIcon={
                        //     <Badge badgeContent={4} color="info">
                        //         <RefreshIcon color="secondary" />
                        //     </Badge>
                        // }
                    >
                        Refresh
                    </ButtonComp>
                    <Typography variant="h3">Filters & Search</Typography>

                    {/* <OrganisationList {...props} /> */}
                    <Box className="menus">
                        <Box className="sort-by-container">
                            <Box
                                className={
                                    !openSortByMenu
                                        ? 'sort-by-menu'
                                        : 'sort-by-menu open-menu'
                                }
                                onClick={() => {
                                    setOpenSortByMenu(!openSortByMenu);
                                }}
                                aria-expanded={openSortByMenu}
                                role="button"
                                aria-controls="panel-sort-by-listing-sidebar"
                                id="sort-by-listing-sidebar"
                            >
                                <Box>
                                    <Typography
                                        className="sort-by-heading"
                                        variant="h4"
                                        data-testid="sort-by-test"
                                    >
                                        Sort by
                                    </Typography>
                                </Box>
                                <Box>
                                    {!openSortByMenu && (
                                        <ArrowDropDownIcon className="icon-drop-down-color down" />
                                    )}
                                    {openSortByMenu && (
                                        <ArrowDropDownIcon className="icon-drop-down-color up" />
                                    )}
                                </Box>
                            </Box>
                            <Collapse
                                in={openSortByMenu}
                                className="open-menu"
                                role="region"
                                id="panel-sort-by-listing-sidebar"
                                aria-labelledby="sort-by-listing-sidebar"
                            >
                                <Box className="menu-list">
                                    <FormControl id="sort-by-radio-group">
                                        <FormLabel
                                            id="radio-buttons-group-label-sortby"
                                            hidden
                                        >
                                            Sort by
                                        </FormLabel>
                                        <RadioGroup
                                            aria-labelledby="radio-buttons-group-label-sortby"
                                            defaultValue="oldestToNew"
                                            name="radio-buttons-group-sortby"
                                            value={sortBy}
                                            onChange={handleChangeSortBy}
                                        >
                                            {/* <AppOutlinedRadioInput
                                                value="statusAscending"
                                                label="Status from A-z"
                                            />
                                            <AppOutlinedRadioInput
                                                value="statusDescending"
                                                label="Status from Z-a"
                                            /> */}
                                            <AppOutlinedRadioInput
                                                value="oldestToNew"
                                                label="Oldest to new"
                                            />
                                            <AppOutlinedRadioInput
                                                value="dateOfUpload"
                                                label="New to oldest"
                                            />
                                            {/* <AppOutlinedRadioInput
                                                value="desDaysLeftToSLA"
                                                label="Days left to SLA"
                                            />
                                            <AppOutlinedRadioInput
                                                value="daysLeftToSLA"
                                                label="Days overdue"
                                            />
                                            <AppOutlinedRadioInput
                                                value="uploadAge"
                                                label="Upload age"
                                            />
                                            <AppOutlinedRadioInput
                                                value="escalatedAge"
                                                label="Escalated age"
                                            />
                                            <AppOutlinedRadioInput
                                                value="desEscalatedAge"
                                                label="Original age"
                                            />
                                            <AppOutlinedRadioInput
                                                value="dateCompleted"
                                                label="Date Completed"
                                            />
                                            <AppOutlinedRadioInput
                                                value="desDateCompleted"
                                                label="Date Started"
                                            />
                                            <AppOutlinedRadioInput
                                                value="clientAscending"
                                                label="Client from A-z"
                                            />
                                            <AppOutlinedRadioInput
                                                value="clientDescending"
                                                label="Client from Z-a"
                                            />
                                            <AppOutlinedRadioInput
                                                value="binAscending"
                                                label="Bin from smallest"
                                            />
                                            <AppOutlinedRadioInput
                                                value="binDescending"
                                                label="Bin to higher"
                                            />
                                            <AppOutlinedRadioInput
                                                value="loanAscending"
                                                label="Loan No. order asc"
                                            />
                                            <AppOutlinedRadioInput
                                                value="loanDescending"
                                                label="Loan No. order desc"
                                            />
                                            <AppOutlinedRadioInput
                                                value="highlighted"
                                                label="Highlighted"
                                            /> */}
                                        </RadioGroup>
                                    </FormControl>
                                </Box>
                            </Collapse>
                        </Box>

                        <Box className="search-by-container">
                            <Box
                                className={
                                    !openSearchByMenu
                                        ? 'search-by-menu'
                                        : 'search-by-menu open-menu'
                                }
                                onClick={() => {
                                    setOpenSearchMenu(!openSearchByMenu);
                                }}
                                aria-expanded={openSearchByMenu}
                                role="button"
                                aria-controls="panel-search-by-listing-sidebar"
                                id="search-by-listing-sidebar"
                            >
                                <Box>
                                    <Typography
                                        className="search-by-heading"
                                        variant="h4"
                                        data-testid="search-by-test"
                                    >
                                        Search by
                                    </Typography>
                                </Box>
                                <Box>
                                    {!openSearchByMenu && (
                                        <ArrowDropDownIcon className="icon-drop-down-color down" />
                                    )}
                                    {openSearchByMenu && (
                                        <ArrowDropDownIcon className="icon-drop-down-color up" />
                                    )}
                                </Box>
                            </Box>
                            <Collapse
                                in={openSearchByMenu}
                                className="open-menu"
                                role="region"
                                id="panel-search-by-listing-sidebar"
                                aria-labelledby="search-by-listing-sidebar"
                            >
                                <Formik
                                    initialValues={{
                                        search_loan: loanNumber,
                                        search_bin: binNumber,
                                        search_client: clientName,
                                        search_operator: operatorId,
                                        search_cm9: cm9Number,
                                        search_datepicker_uploaddate:
                                            uploadDate,
                                        search_datepicker_completeddate:
                                            completedDate,
                                        search_sladate: slaDaysLeft,
                                        search_uploadage: uploadAge,
                                    }}
                                    enableReinitialize
                                    onSubmit={(formValues: any, formik) => {
                                        setPage(0);
                                        reqFilterPacket(
                                            formValues.search_loan,
                                            formValues.search_bin,
                                            formValues.search_client,
                                            formValues.search_operator,
                                            formValues.search_cm9,
                                            formValues.search_datepicker_uploaddate,
                                            formValues.search_datepicker_completeddate,
                                            parseInt(
                                                formValues.search_sladate,
                                                10
                                            ),
                                            parseInt(
                                                formValues.search_uploadage,
                                                10
                                            ),
                                            formik
                                        );
                                    }}
                                    innerRef={formikRef}
                                >
                                    {({
                                        handleSubmit,
                                        // isSubmitting,
                                        // isValid,
                                    }) => (
                                        <>
                                            <Box className="menu-list">
                                                <FormControl id="search-by-radio-group">
                                                    <FormLabel
                                                        id="radio-buttons-group-label-search"
                                                        hidden
                                                    >
                                                        Search by
                                                    </FormLabel>
                                                    <FormGroup
                                                        aria-labelledby="radio-buttons-group-label-search"
                                                        role="group"
                                                        // defaultValue="cmp9Number"
                                                        // name="radio-buttons-group-search"
                                                        // value={searchBy}
                                                        // onChange={handleChangeSearchBy}
                                                    >
                                                        {/* <AppOutlinedRadioInput
                                            value="cmp9Number"
                                            label="CM9 Record Number"
                                        /> */}
                                                        <AppRadioBox
                                                            checked={
                                                                checkedByLoan
                                                            }
                                                            color="primary"
                                                            value="loanNumber"
                                                            label="Envelope Number"
                                                            onChange={() => {
                                                                if (
                                                                    checkedByLoan ===
                                                                    true
                                                                ) {
                                                                    formikRef.current?.setFieldValue(
                                                                        'search_loan',
                                                                        ''
                                                                    );
                                                                    handleSubmit();
                                                                }
                                                                setByLoan(
                                                                    !checkedByLoan
                                                                );
                                                            }}
                                                        />
                                                        {checkedByLoan && (
                                                            <AppFormikTextField
                                                                outerLabel
                                                                name="search_loan"
                                                                size="small"
                                                                placeholder="Type here"
                                                                onEnter={
                                                                    handleSubmit
                                                                }
                                                                autoFocus
                                                                autoComplete="off"
                                                            />
                                                        )}
                                                        <AppRadioBox
                                                            checked={
                                                                checkedByBin
                                                            }
                                                            color="primary"
                                                            value="binNumber"
                                                            label="Reference Number"
                                                            onChange={() => {
                                                                if (
                                                                    checkedByBin ===
                                                                    true
                                                                ) {
                                                                    formikRef.current?.setFieldValue(
                                                                        'search_bin',
                                                                        ''
                                                                    );
                                                                    handleSubmit();
                                                                }
                                                                setByBin(
                                                                    !checkedByBin
                                                                );
                                                            }}
                                                        />
                                                        {checkedByBin && (
                                                            <AppFormikTextField
                                                                outerLabel
                                                                name="search_bin"
                                                                size="small"
                                                                placeholder="Type here"
                                                                onEnter={
                                                                    handleSubmit
                                                                }
                                                                autoFocus
                                                                autoComplete="off"
                                                            />
                                                        )}
                                                        <AppRadioBox
                                                            checked={
                                                                checkedByClient
                                                            }
                                                            color="primary"
                                                            value="clientName"
                                                            label="Checklist name"
                                                            onChange={() => {
                                                                if (
                                                                    checkedByClient ===
                                                                    true
                                                                ) {
                                                                    formikRef.current?.setFieldValue(
                                                                        'search_client',
                                                                        ''
                                                                    );
                                                                    handleSubmit();
                                                                }
                                                                setByClient(
                                                                    !checkedByClient
                                                                );
                                                            }}
                                                        />
                                                        {checkedByClient && (
                                                            <AppFormikTextField
                                                                outerLabel
                                                                name="search_client"
                                                                size="small"
                                                                placeholder="Type here"
                                                                onEnter={
                                                                    handleSubmit
                                                                }
                                                                autoFocus
                                                                autoComplete="off"
                                                            />
                                                        )}
                                                        <AppRadioBox
                                                            checked={
                                                                checkedByOperator
                                                            }
                                                            color="primary"
                                                            value="operatorId"
                                                            label="Operator name"
                                                            onChange={() => {
                                                                if (
                                                                    checkedByOperator ===
                                                                    true
                                                                ) {
                                                                    formikRef.current?.setFieldValue(
                                                                        'search_operator',
                                                                        ''
                                                                    );
                                                                    handleSubmit();
                                                                }
                                                                setByOperator(
                                                                    !checkedByOperator
                                                                );
                                                            }}
                                                        />
                                                        {checkedByOperator && (
                                                            <AppFormikTextField
                                                                outerLabel
                                                                name="search_operator"
                                                                size="small"
                                                                placeholder="Type here"
                                                                onEnter={
                                                                    handleSubmit
                                                                }
                                                                autoFocus
                                                                autoComplete="off"
                                                            />
                                                        )}
                                                        <AppRadioBox
                                                            checked={
                                                                checkedByCM9
                                                            }
                                                            color="primary"
                                                            value="cm9"
                                                            label="CM Number"
                                                            onChange={() => {
                                                                if (
                                                                    checkedByCM9 ===
                                                                    true
                                                                ) {
                                                                    formikRef.current?.setFieldValue(
                                                                        'search_cm9',
                                                                        ''
                                                                    );
                                                                    handleSubmit();
                                                                }
                                                                setByCM9(
                                                                    !checkedByCM9
                                                                );
                                                            }}
                                                        />
                                                        {checkedByCM9 && (
                                                            <AppFormikTextField
                                                                outerLabel
                                                                name="search_cm9"
                                                                size="small"
                                                                placeholder="Type here"
                                                                onEnter={
                                                                    handleSubmit
                                                                }
                                                                autoFocus
                                                                autoComplete="off"
                                                            />
                                                        )}
                                                        <AppRadioBox
                                                            checked={
                                                                checkedByUploadDate
                                                            }
                                                            color="primary"
                                                            value="uploadedDate"
                                                            label="Date of upload"
                                                            onChange={() => {
                                                                if (
                                                                    checkedByUploadDate ===
                                                                    true
                                                                ) {
                                                                    formikRef.current?.setFieldValue(
                                                                        'search_datepicker_uploaddate',
                                                                        ''
                                                                    );
                                                                    handleSubmit();
                                                                }
                                                                setByUploadDate(
                                                                    !checkedByUploadDate
                                                                );
                                                            }}
                                                        />
                                                        {checkedByUploadDate && (
                                                            <AppFormikDatePicker
                                                                autoFocus
                                                                name="search_datepicker_uploaddate"
                                                                testid="datepicker-dropdown"
                                                                InputProps={{
                                                                    name: 'search_datepicker_uploaddate',
                                                                    'aria-labelledby':
                                                                        'uploadDate-datepicker-label',
                                                                    notched:
                                                                        false,
                                                                }}
                                                                value={
                                                                    undefined
                                                                }
                                                                // onChange={() =>
                                                                //      console.log(
                                                                //          'date'
                                                                //      )
                                                                // }
                                                                renderInput={(
                                                                    props: any
                                                                ) => (
                                                                    <TextField
                                                                        {...props}
                                                                    />
                                                                )}
                                                                autoComplete="off"
                                                                onEnter={
                                                                    handleSubmit
                                                                }
                                                            />
                                                        )}
                                                        <AppRadioBox
                                                            checked={
                                                                checkedByCompletedDate
                                                            }
                                                            color="primary"
                                                            value="completedDate"
                                                            label="Completed Date"
                                                            onChange={() => {
                                                                if (
                                                                    checkedByCompletedDate ===
                                                                    true
                                                                ) {
                                                                    formikRef.current?.setFieldValue(
                                                                        'search_datepicker_completeddate',
                                                                        ''
                                                                    );
                                                                    handleSubmit();
                                                                }
                                                                setByCompletedDate(
                                                                    !checkedByCompletedDate
                                                                );
                                                            }}
                                                        />
                                                        {checkedByCompletedDate && (
                                                            <AppFormikDatePicker
                                                                autoFocus
                                                                name="search_datepicker_completeddate"
                                                                testid="datepicker-dropdown"
                                                                InputProps={{
                                                                    name: 'search_datepicker_completeddate',
                                                                    'aria-labelledby':
                                                                        'completedDate-datepicker-label',
                                                                    notched:
                                                                        false,
                                                                }}
                                                                value={
                                                                    undefined
                                                                }
                                                                // onChange={() =>
                                                                //     console.log(
                                                                //         'date'
                                                                //     )
                                                                // }
                                                                renderInput={(
                                                                    props: any
                                                                ) => (
                                                                    <TextField
                                                                        {...props}
                                                                    />
                                                                )}
                                                                autoComplete="off"
                                                                onEnter={
                                                                    handleSubmit
                                                                }
                                                            />
                                                        )}
                                                        <AppRadioBox
                                                            checked={
                                                                checkedBySLADate
                                                            }
                                                            color="primary"
                                                            value="slaDate"
                                                            label="Days left to sla"
                                                            onChange={() => {
                                                                if (
                                                                    checkedBySLADate ===
                                                                    true
                                                                ) {
                                                                    formikRef.current?.setFieldValue(
                                                                        'search_sladate',
                                                                        ''
                                                                    );
                                                                    handleSubmit();
                                                                }
                                                                setBySLADate(
                                                                    !checkedBySLADate
                                                                );
                                                            }}
                                                        />
                                                        {checkedBySLADate && (
                                                            <AppFormikTextFieldNumber
                                                                outerLabel
                                                                name="search_sladate"
                                                                size="small"
                                                                placeholder="Type here"
                                                                positiveLookAhead
                                                                onEnter={
                                                                    handleSubmit
                                                                }
                                                                autoFocus
                                                                autoComplete="off"
                                                            />
                                                        )}
                                                        <AppRadioBox
                                                            checked={
                                                                checkedByUploadAge
                                                            }
                                                            color="primary"
                                                            value="uploadAge"
                                                            label="Upload Age"
                                                            onChange={() => {
                                                                if (
                                                                    checkedByUploadAge ===
                                                                    true
                                                                ) {
                                                                    formikRef.current?.setFieldValue(
                                                                        'search_uploadage',
                                                                        ''
                                                                    );
                                                                    handleSubmit();
                                                                }
                                                                setByUploadAge(
                                                                    !checkedByUploadAge
                                                                );
                                                            }}
                                                        />
                                                        {checkedByUploadAge && (
                                                            <AppFormikTextFieldNumber
                                                                outerLabel
                                                                name="search_uploadage"
                                                                size="small"
                                                                positiveLookAhead
                                                                placeholder="Recently uploaded days"
                                                                onEnter={
                                                                    handleSubmit
                                                                }
                                                                autoFocus
                                                                autoComplete="off"
                                                            />
                                                        )}
                                                    </FormGroup>
                                                </FormControl>
                                            </Box>
                                            <Box className="menu-list">
                                                <FormControl id="search-by-textual">
                                                    <form autoComplete="off">
                                                        <Grid item xs={12}>
                                                            {/* <AppPrimaryButton
                                                                className="btn-small"
                                                                fullWidth
                                                                title="Submit"
                                                                isLoading={
                                                                    isSubmitting
                                                                }
                                                                loadingSize={22}
                                                                disabled={
                                                                    (!checkedByBin &&
                                                                        !checkedByClient &&
                                                                        !checkedByLoan &&
                                                                        !checkedByOperator &&
                                                                        !checkedByCM9 &&
                                                                        !checkedByUploadDate &&
                                                                        !checkedByCompletedDate &&
                                                                        !checkedBySLADate &&
                                                                        !checkedByUploadAge) ||
                                                                    isSubmitting ||
                                                                    !isValid
                                                                }
                                                                onClick={
                                                                    handleSubmit
                                                                }
                                                            /> */}
                                                            <Box mt={2} />
                                                            <AppPrimaryButton
                                                                className="btn-small-neutral"
                                                                fullWidth
                                                                title="Clear"
                                                                loadingSize={22}
                                                                onClick={
                                                                    HandleClearInSearchBox
                                                                }
                                                            />
                                                        </Grid>
                                                    </form>
                                                </FormControl>
                                            </Box>
                                        </>
                                    )}
                                </Formik>
                            </Collapse>
                        </Box>

                        {/* Temporary wait API */}
                        <Box className="filter-by-packet-status-container">
                            <Box
                                className={
                                    !openFilterByPacketStatusMenu
                                        ? 'filter-by-packet-status-menu'
                                        : 'filter-by-packet-status-menu open-menu'
                                }
                                onClick={() => {
                                    setOpenFilterPacketStatusMenu(
                                        !openFilterByPacketStatusMenu
                                    );
                                }}
                                aria-expanded={openFilterByPacketStatusMenu}
                                role="button"
                                aria-controls="panel-filter-by-status-listing-sidebar"
                                id="filter-by-status-listing-sidebar"
                            >
                                <Box>
                                    <Typography
                                        className="filter-by-packet-status-heading"
                                        variant="h4"
                                        data-testid="filter-by-status-test"
                                    >
                                        Filter by Cross Check Status
                                    </Typography>
                                </Box>
                                <Box>
                                    {!openFilterByPacketStatusMenu && (
                                        <ArrowDropDownIcon className="icon-drop-down-color down" />
                                    )}
                                    {openFilterByPacketStatusMenu && (
                                        <ArrowDropDownIcon className="icon-drop-down-color up" />
                                    )}
                                </Box>
                            </Box>
                            <Collapse
                                in={openFilterByPacketStatusMenu}
                                className="open-menu"
                                role="region"
                                id="panel-filter-by-status-listing-sidebar"
                                aria-labelledby="filter-by-status-listing-sidebar"
                            >
                                <Box className="menu-list">
                                    <FormControl id="filter-by-packet-status-radio-group">
                                        <FormLabel
                                            id="radio-buttons-group-label-filter-by-packet-status"
                                            hidden
                                        >
                                            Filter by Cross Check Status
                                        </FormLabel>
                                        <FormGroup
                                            aria-labelledby="radio-buttons-group-label-filter-by-packet-status"
                                            role="group"
                                        >
                                            {checkboxStatus
                                                .filter(
                                                    (e) =>
                                                        (e.value !==
                                                            'escalated' &&
                                                            role ===
                                                                'operator') ||
                                                        role !== 'operator'
                                                )
                                                .map((checkbox) => (
                                                    <AppRadioBox
                                                        checked={
                                                            packetStatus.length ===
                                                            0
                                                                ? checkbox.value ===
                                                                  'viewall'
                                                                : packetStatus.includes(
                                                                      checkbox.value
                                                                  )
                                                        }
                                                        color="primary"
                                                        value={checkbox.value}
                                                        onChange={
                                                            handleChangePacketStatus
                                                        }
                                                        label={checkbox.label}
                                                    />
                                                ))}
                                        </FormGroup>
                                    </FormControl>
                                </Box>
                            </Collapse>
                        </Box>

                        <Box className="filter-by-packet-type-container">
                            <Box
                                className={
                                    !openFilterByPacketTypeMenu
                                        ? 'filter-by-packet-type-menu'
                                        : 'filter-by-packet-type-menu open-menu'
                                }
                                onClick={() => {
                                    setOpenFilterPacketTypeMenu(
                                        !openFilterByPacketTypeMenu
                                    );
                                }}
                                aria-expanded={openFilterByPacketStatusMenu}
                                role="button"
                                aria-controls="panel-filter-by-type-listing-sidebar"
                                id="filter-by-type-listing-sidebar"
                            >
                                <Box>
                                    <Typography
                                        className="filter-by-packet-type-heading"
                                        variant="h4"
                                        data-testid="filter-by-type-test"
                                    >
                                        Filter by Cross Check Type
                                    </Typography>
                                </Box>
                                <Box>
                                    {!openFilterByPacketTypeMenu && (
                                        <ArrowDropDownIcon className="icon-drop-down-color down" />
                                    )}
                                    {openFilterByPacketTypeMenu && (
                                        <ArrowDropDownIcon className="icon-drop-down-color up" />
                                    )}
                                </Box>
                            </Box>
                            <Collapse
                                in={openFilterByPacketTypeMenu}
                                className="open-menu"
                                role="region"
                                id="panel-filter-by-type-listing-sidebar"
                                aria-labelledby="filter-by-type-listing-sidebar"
                            >
                                <Box className="menu-list">
                                    <FormControl id="filter-by-packet-type-radio-group">
                                        <FormLabel
                                            id="radio-buttons-group-label-filter-by-packet-type"
                                            hidden
                                        >
                                            Filter by Cross Check Type
                                        </FormLabel>
                                        <FormGroup aria-labelledby="radio-buttons-group-label-filter-by-packet-type">
                                            {checkboxType.map((checkbox) => (
                                                <AppRadioBox
                                                    checked={
                                                        packetType.length === 0
                                                            ? checkbox.value ===
                                                              'viewall'
                                                            : packetType.includes(
                                                                  checkbox.value
                                                              )
                                                    }
                                                    color="primary"
                                                    value={checkbox.value}
                                                    onChange={
                                                        handleChangePacketType
                                                    }
                                                    label={checkbox.label}
                                                />
                                            ))}
                                        </FormGroup>
                                    </FormControl>
                                </Box>
                            </Collapse>
                        </Box>
                        <Box className="container-search">
                            <Formik
                                initialValues={{
                                    smallInput: '',
                                }}
                                enableReinitialize
                                onSubmit={(formValues, formik) => {
                                    setSubmit(true);

                                    handleReset(formik, resetSearch);
                                }}
                            >
                                {({
                                    handleSubmit,
                                    // isSubmitting,
                                    isValid,
                                }) => (
                                    <form autoComplete="off">
                                        <Grid item xs={12}>
                                            {(checkedByBin ||
                                                checkedByClient ||
                                                checkedByLoan ||
                                                checkedByOperator ||
                                                checkedByCM9 ||
                                                checkedByUploadDate ||
                                                checkedByCompletedDate ||
                                                checkedBySLADate ||
                                                checkedByUploadAge ||
                                                searchBy ||
                                                sortBy ||
                                                textField ||
                                                packetStatus.length > 0 ||
                                                packetType.length > 0) && (
                                                <AppPrimaryButton
                                                    className="btn-small"
                                                    fullWidth
                                                    title="Reset Current Filter"
                                                    isLoading={isSubmitting}
                                                    loadingSize={22}
                                                    disabled={
                                                        isSubmitting || !isValid
                                                    }
                                                    onClick={handleSubmit}
                                                />
                                            )}
                                        </Grid>
                                    </form>
                                )}
                            </Formik>
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }
);

// const mapStateToProps = (state: any): any => ({
//     profileState: state.profileState,
//     authState: state.authState,
//     baseAppState: state.baseAppState,
// });

// const mapDispatchToProps = (): any => ({});

export default FilterSidebar;
